"use client";

import { fanduel as fd } from "@fanduel/formation-tokens";
import TeamContainer from "@/components/headToHead/TeamContainer";
import TeamLog from "./TeamLog";
import { TeamGameLog } from "./types";
import styles from "./OverviewGameLog.module.scss";

interface TeamData {
  teamName: string;
  teamIcon: string;
  teamColor: string;
  gameLog: TeamGameLog[];
}

interface OverviewGameLogDisplayProps {
  homeTeam: TeamData;
  awayTeam: TeamData;
}

export default function OverviewGameLogDisplay({
  homeTeam,
  awayTeam,
}: OverviewGameLogDisplayProps) {
  return (
    <div className={styles.gameLogContainer}>
      <div className={styles.teamsContainer}>
        <TeamContainer
          teamName={awayTeam.teamName}
          teamIcon={awayTeam.teamIcon}
          teamColor={awayTeam.teamColor || fd.colors.contentStrong}
        >
          <TeamLog gameLog={awayTeam.gameLog} />
        </TeamContainer>
        <TeamContainer
          teamName={homeTeam.teamName}
          teamIcon={homeTeam.teamIcon}
          teamColor={homeTeam.teamColor || fd.colors.contentStrong}
        >
          <TeamLog gameLog={homeTeam.gameLog} />
        </TeamContainer>
      </div>
    </div>
  );
}
